import u from "./highrise661.mjs";
var r = Object.create, c = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!u(t))
      return {};
    if (r)
      return r(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}();
export {
  c as default
};
